<template>
  <div id="page-user-list" class="p-6">
    <div class="header-custome">
      <div>
        <h3>CheckIn Location List</h3>
      </div>
      <div
        class="chekin-header-right location-header-right flex justify-end items-center"
      >
        <div class="mr-2">
          <!-- <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" class="ml-1" /> -->
          <vs-input
            class="mr-0 w-full"
            v-model="searchQuery"
            @input="updateSearchQuery"
            placeholder="Search Location"
          />
        </div>
        <vs-button
          @click="openAddLocPopup()"
          color="#00ccfe"
          type="filled"
          class="flex items-center justify-center mr-3 add-loc-btn"
        >
          <img
            src="../../../assets/images/checkin-images/add-location.png"
            class="mr-2"
          />
          ADD LOCATION
        </vs-button>
        <!-- <vs-button @click="popupActive3=true" color="#00ccfe" type="filled" class="flex items-center justify-center">
              <feather-icon icon="UserPlusIcon" svgClasses="h-6 w-6" class="mr-2" /> ADD USER
            </vs-button> -->
      </div>
    </div>

    <vs-popup
      class="holamundo chekin_location-add"
      title="Add New Location"
      :active.sync="IsAddLocationPopupOpen"
      @close="IsAddLocationPopupOpen = true"
    >
      <div class="location-add-header">
        <h3 v-if="singleLocationData && singleLocationData.Address">
          Update Location
        </h3>
        <h3 v-else>Add New Location</h3>
        <vs-button radius color="#000" type="flat" class="location-pop-close"
          ><feather-icon
            icon="XIcon"
            svgClasses="h-8 w-8"
            @click="IsAddLocationPopupOpen = false"
        /></vs-button>
      </div>
      <location-add
        v-if="IsAddLocationPopupOpen"
        key="locationKey"
        class="mt-4"
        :data="singleLocationData"
        :currentLoc="currentLocation"
        @saveLocationSuccess="saveLocationSuccess"
        @closeLocationPopup="closeLocationPopup"
      />
    </vs-popup>

    <ag-grid-vue
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-full my-4 ag-grid-table ag-grid table location-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="getLocationList"
      rowSelection="multiple"
      rowMultiSelectWithClick="false"
      suppressRowClickSelection="true"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :enableRtl="$vs.rtl"
    ></ag-grid-vue>
    <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
  </div>
</template>
  <script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
//store
import moduleCheckinLocationManagement from "@/store/checkin-location-management/moduleCheckinLocationManagement.js";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererType from "./cell-renderer/CellRendererType.vue";
import CellRendererAttendeeMappedLocation from "./cell-renderer/CellRendererAttendeeMappedLocation.vue";
import CellRendererLocationImage from "./cell-renderer/CellRendererLocationImage.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import vSelect from "vue-select";
import LocationAdd from "./LocationAdd.vue";
// Store Module
import moduleVenueManagement from "@/store/venue-management/moduleManagement.js";
import { bus } from "../../../main";
var vm;
export default {
  components: {
    "v-select": vSelect,
    AgGridVue,
    CellRendererActions,
    CellRendererAttendeeMappedLocation,
    CellRendererLocationImage,
    LocationAdd,
    CellRendererStatus,
    CellRendererType,
  },

  data() {
    return {
      locationKey: 0,
      searchQuery: "",
      gridApi: null,
      singleLocationData: {},
      currentLocation: {},
      locationData: [],
      IsAddLocationPopupOpen: false,
      popupActive2: false,
      popupActive3: false,
      popupActive4: false,
      radios1: "Both",
      number: 34,
      selected: ["foo", "bar"],
      options: ["foo", "bar", "baz"],
      selected2: ["foo", "bar"],
      options: ["foo", "bar", "baz"],
      gridOptions: {},
      columnDefs: [
        {
          headerName: "Location",
          field: "Name",
          filter: true,
          width: 400,
          height: 500,
          cellRendererFramework: "CellRendererLocationImage",
          unSortIcon: true,
          cellRendererParams: (params) => {
            return {
              Name: params.data.Name,
              ImageUrl: params.data.ImageUrl,
            };
          },
        },

        {
          headerName: "Type",
          field: "CheckinType",
          filter: true,
          width: 400,
          unSortIcon: true,
          cellRendererFramework: "CellRendererType",
          cellRendererParams: (params) => {
            return {
              CheckinType: params.data.CheckinType,
            };
          },
        },
        {
          headerName: "No. of Assigned Users",
          field: "Attendees.Count",
          filter: true,
          width: 100,
          height: 500,
          cellRendererFramework: "CellRendererAttendeeMappedLocation",
          unSortIcon: true,
          cellRendererParams: (params) => {
            return {
              Count: params.data.Attendees.Count,
              Attendee: params.data.Attendees.Data,
              LocationId: params.data.LocationId,
            };
          },
        },
        // {
        //   headerName: "Status",
        //   field: "IsPublished",
        //   filter: true,
        //   width: 150,
        //   cellRendererFramework: "CellRendererStatus",
        //   cellRendererParams: (params) => {
        //     return {
        //       id: params.data.AttendeeId,
        //       IsPublished: params.data.IsPublished,
        //     };
        //   },
        // },

        {
          headerName: "Actions",
          filter: false,
          sortable: false,
          width: 150,
          height: 500,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: (params) => {
            return {
              data: params.data,
            };
          },
          pinned: "right",
        },
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
    };
  },
  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
    getLocationList() {
      return this.locationData;
    },
  },
  methods: {
    fetchUserCurrentLocation() {
      this.$store
        .dispatch("checkinlocationManagement/fetchUserInitialLocation")
        .then((res) => {
          this.currentLocation = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    openAddLocPopup() {
      if (this.singleLocationData && this.singleLocationData.Name) {
        vm.singleLocationData = {};
      }
      vm.locationKey++;
      vm.IsAddLocationPopupOpen = true;
    },
    updateSearchQuery(val) {
      console.log("called====", val);

      this.gridApi.setQuickFilter(val);
    },
    fetchLocations() {
      this.$vs.loading();
      vm.locationData = [];
      this.$store
        .dispatch("checkinlocationManagement/fetchGeoCheckinLocations")
        .then((res) => {
          if (res && res.data[0]) {
            vm.locationData = [];

            res.data[0].map(function (item) {
              if (item.IsPublished) {
                vm.locationData.push(item);
              }
            });
          }

          //this.locationData = res.data[0];
          if (this.locationData && this.locationData.length > 0) {
            this.locationData.sort((a, b) => {
              console.log("a====", a.CreatedDate["_seconds"]);

              const aDate = new Date(a.CreatedDate["_seconds"] * 1000);
              const bDate = new Date(b.CreatedDate["_seconds"] * 1000);
              return bDate.getTime() - aDate.getTime();
            });
          }
          // let publishedArray = res.data[0];
          // for (let i = 0; i < publishedArray.length; i++) {
          //   if (publishedArray[i].IsPublished) {
          //     this.locationData.push(publishedArray[i]);
          //   }
          // }

          this.pageLoaded = true;
          this.$vs.loading.close();
        });
    },
    saveLocationSuccess(mode) {
      this.IsAddLocationPopupOpen = false;
      this.fetchLocations();
    },
    closeLocationPopup() {
      this.IsAddLocationPopupOpen = false;
      this.fetchLocations();
    },
    changeLocationStatus(data) {
      // data.IsPublished = false;
      this.$vs.loading();

      this.$store
        .dispatch("checkinlocationManagement/updateLocation", {
          id: data.LocationId,
          data: data,
        })
        .then((res) => {
          this.$vs.loading.close();
          if (res.status == 200) {
            this.fetchLocations();
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Location",
              text: "Location updated successfully.",
            });
            this.$emit("saveLocationSuccess", 1);
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              title: "success",
              text: "Location not updated successfully.",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            title: "Location",
            text: "Something went wrong!",
          });
        });
    },
  },
  mounted() {
    this.gridOptions.api.showLoadingOverlay();
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  destroyed() {
    bus.$off("editLocation");
    bus.$off("changeLocationStatus");
  },
  created() {
    vm = this;
    if (!moduleCheckinLocationManagement.isRegistered) {
      this.$store.registerModule(
        "checkinlocationManagement",
        moduleCheckinLocationManagement
      );
      moduleCheckinLocationManagement.isRegistered = true;
    }
    if (!moduleVenueManagement.isRegistered) {
      this.$store.registerModule("venueManagement", moduleVenueManagement);
      moduleVenueManagement.isRegistered = true;
    }
    this.fetchLocations();
    this.fetchUserCurrentLocation();

    bus.$on("editLocation", async (location) => {
      console.log("edit===location", location);
      vm.openAddLocPopup();
      vm.singleLocationData = location;
    });
    bus.$on("changeLocationStatus", async (location) => {
      this.changeLocationStatus(location);
    });
  },
};
</script>
